import { cx } from 'class-variance-authority';
import MaskedInput from 'react-text-mask';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

interface Mask {
  prefix?: string;
  suffix?: string;
  includeThousandsSeparator?: boolean;
  thousandsSeparatorSymbol?: string;
  allowDecimal?: boolean;
  decimalSymbol?: string;
  decimalLimit?: number;
  requireDecimal?: boolean;
  allowNegative?: boolean;
  allowLeadingZeroes?: boolean;
  integerLimit?: number;
}

const defaultMaskOptions: Mask = {
  prefix: '',
  suffix: '',
  includeThousandsSeparator: true,
  thousandsSeparatorSymbol: ',',
  allowDecimal: false,
  decimalSymbol: '',
  decimalLimit: 2, // how many digits allowed after the decimal
  integerLimit: 6, // limit length of integer numbers
  allowNegative: false,
  allowLeadingZeroes: false,
  requireDecimal: false,
};

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  inputmode?: string;
  maskOptions?: Mask;
  error?: boolean;
}

const CurrencyInput = ({
  maskOptions,
  inputMode,
  disabled,
  error,
  ...inputProps
}: Props) => {
  const currencyMask = createNumberMask({
    ...defaultMaskOptions,
    ...maskOptions,
  });
  return (
    <MaskedInput
      mask={currencyMask}
      {...inputProps}
      onFocus={(e) => e.target.select()}
      disabled={disabled}
      inputMode={inputMode ?? 'text'}
      className={cx([
        'rounded-[10px] w-full grow cursor-[inherit] border-none border-transparent bg-transparent text-[1.5rem] leading-[2.25rem] focus:outline-hidden',
        disabled ? 'select-none text-brand-gray' : 'text-brand-black',
        error ? 'border-red-500' : 'border-brand-gray',
      ])}
    />
  );
};

export default CurrencyInput;
